module.exports = __webpack_public_path__ + "static/media/awardBtnEng.81840efa.png";